export function generateClassStyles(settings = require('../../assets/settings').default) {
    let styles = "";
    for (const key in settings) {
        if (typeof(settings[key]) !== 'string' || (!settings[key].startsWith('#') && !key.endsWith('Color'))) {
            continue;
        }
        styles += generateFillClass(settings, key);
        styles += generateStrokeClass(settings, key);
        styles += generateStopColorClass(settings, key);
    }
    return `<style><![CDATA[${styles} text tspan{font-family: '${settings.fontFamily || "Roboto"}', sans-serif !important;}]]>
    <![CDATA[${styles} div span{font-family: '${settings.fontFamily || "Roboto"}', sans-serif !important;}]]>
    </style>`;
}

function generateStrokeClass(settings, key) {
    //stroke is special case, coloring rectangle borders should be achieved through stroke, but borders drawn as paths should be colored with fill
    const classString =
        `
.${key + "--stroke"}{
    stroke: ${settings[key]};
}`
    return classString;
}

function generateStopColorClass(settings, key) {
    // stop-color is used in gradient with <stop> element (to use add to name "--stop")
    const classString =
        `
.${key + "--stop"}{
    stop-color: ${settings[key]};
}`
    return classString;
}

function generateFillClass(settings, key) {
    let classString =
        `
.${key}{
    fill: ${settings[key]};
    color: ${settings[key]};
}`
    if (key === 'bgColor') {
        classString += `
.${key}--bg{
    background: ${settings[key]}
}`
    }
    return classString;
}